import React from "react";
import { useI18next } from 'gatsby-plugin-react-i18next';
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./style.module.scss";

const { 
  tamCalculator,
  tamCalculator__btn,
} = styles;

const TamCalculatorCTA = () => {
  const { language } = useI18next();

  const url =
    language === "de"
    ? 'https://www.dealfront.com/tools/tam-calculator/de/'
    : 'https://www.dealfront.com/tools/tam-calculator/';
    
    const btnText = 
    language === "de"
      ? "Mehr erfahren"
      : "Learn more";

  return (
    <div className={tamCalculator}>
      {language === 'de' ? (
        <StaticImage
          placeholder="none"
          src="../../../../images/cta/cta-tam-calculator-de.png"
          alt="Playbooks-Bannerbild"
        />
      ) : (
        <StaticImage
          placeholder="none"
          src="../../../../images/cta/cta-tam-calculator.png"
          alt="Playbooks banner image"
        />
      )}
      <a href={url} className={tamCalculator__btn}>
        {btnText}
      </a>
    </div>
  );
};

export default TamCalculatorCTA;
